import { render, staticRenderFns } from "./SecretVerify.vue?vue&type=template&id=90917e14&scoped=true"
import script from "./SecretVerify.vue?vue&type=script&lang=js"
export * from "./SecretVerify.vue?vue&type=script&lang=js"
import style0 from "./SecretVerify.vue?vue&type=style&index=0&id=90917e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90917e14",
  null
  
)

export default component.exports